import cn from 'clsx'
import { CareerListing } from '../../../../apps/benmax/src/types/sanity.types';

import s from './HowToApply.module.sass'
import Button from '../Button/Button';

function HowToApply({ listing }: { listing: CareerListing }) {
    const { location, position, salary, disclaimer, applyLink, applyEmail } = listing

    return (
        <div className={s.HowToApply}>
            <h4>How to apply for this role</h4>
            <p>If you think you're the right for us, we'd love to hear from you! Please click the link below to apply for this role.</p>
            <ul>

                {location && (
                    <li>
                        <span className={cn(s.DetailHeading, 'smallCaps')}>Location</span>
                        <span>{location}</span>
                    </li>
                )}

                {position && (
                    <li>
                        <span className={cn(s.DetailHeading, 'smallCaps')}>Position</span>
                        <span>{position}</span>
                    </li>
                )}

                {salary && (
                    <li>
                        <span className={cn(s.DetailHeading, 'smallCaps')}>Salary</span>
                        <span>{salary}</span>
                    </li>
                )}
            </ul>

            {disclaimer && (
                <p>{disclaimer}</p>
            )}

            {applyLink ? (
                <Button className={s.ApplyButton} url={applyLink} title="Apply now" transparent />
            ) : applyEmail ? (
                <Button className={s.ApplyButton} url={`mailto:${applyEmail}`} title="Apply now" transparent />
            ) : null}
        </div>
    )
}


export default HowToApply